/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { Container, Image, Table, Button, Row, Col } from "react-bootstrap";

import Alert from "react-s-alert";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form } from "react-bootstrap";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  admin_get_in_app_templates,
  update_get_in_app_templates,
} from "../../../../store/actions/SuperAdminActions/adminTemplatesAction";
import SelectFilter from "../../../reusableComponents/selectFilter";
import moment from "moment";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { Chip, Divider } from "@material-ui/core";
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

function SuperAdminNotifyUsers(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  let renderData = useSelector((state) => {
    return !isEmpty(state.auth)
      ? state.superAdminTemplates.getInAppTemplates
      : [];
  });

  const downloadData = {
    headers: [
      { label: "ID", key: "id" },
      { label: "User Type", key: "user" },
      { label: "Template Type", key: "type" },
      { label: "Title", key: "title" },
      { label: "Headline", key: "headline" },
      { label: "Sub Text Amount", key: "sub" },
      { label: "Status", key: "status" },
      { label: "Start Date - End Date", key: "date" },
      { label: "Triggered Time", key: "time" },
      { label: "Selected Cities / Area", key: "city" },
    ],
    data: renderData
      ? renderData?.map((ele) => {
          return {
            id: ele?.id || ele?._id,
            user: ele.userType === "USER" ? "User" : "Vendor",
            type:
              ele.templateType === "TEXT"
                ? "Text"
                : ele.templateType === "IMAGE"
                ? "Image"
                : "Text + Image",
            title: ele?.title,
            heading: ele?.heading?.text,
            sub: ele?.content?.text,
            status: ele?.status,
            date: `${moment(ele.startDate).format("ll")}-${moment(
              ele.endDate
            ).format("ll")}`,
            time: `${ele?.startTime}-${ele?.endTime}`,
            city: ele.locationList.join(","),
          };
        })
      : [],
  };
  // Filter Data

  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    type: "",
    search: false,
  });

  const userFilter = [
    { title: "Title", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
  ];

  const filterData = {
    type: [
      { value: "TEXT", name: "Text" },
      { value: "TEXT_IMAGE", name: "Text +  Image" },
      { value: "IMAGE", name: "Image" },
    ],
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (sort === "A-Z") {
    renderData = renderData.sort((a, b) => {
      if (a?.title?.toLowerCase() < b?.title?.toLowerCase()) return -1;
      if (a?.title?.toLowerCase() > b?.title?.toLowerCase()) return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    renderData = renderData.sort((a, b) => {
      if (a?.title?.toLowerCase() < b?.title?.toLowerCase()) return 1;
      if (a?.title?.toLowerCase() > b?.title?.toLowerCase()) return -1;
      return 0;
    });
  }

  if (filter.search) {
    if (filter.type)
      renderData = renderData.filter((ele) => ele?.type === filter.type);
  }

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    dispatch(admin_get_in_app_templates(auth.accessToken, data));
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(admin_get_in_app_templates(auth.accessToken, dateQuery));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  renderData = renderData.filter((item) => {
    return (
      item?.title?.toLowerCase().includes(search.toLowerCase()) ||
      item?.heading?.text?.toLowerCase().includes(search.toLowerCase()) ||
      item?.id?.toLowerCase().includes(search.toLowerCase()) ||
      item?._id?.toLowerCase().includes(search.toLowerCase())
    );
  });

  const onSuccess = (data) => {
    console.log(data, "updated");
    // renderData = renderData.map((ele) => {
    //   if (ele._id == data._id) {
    //     return data;
    //   } else return ele;
    // });
    // dispatch(admin_get_in_app_templates(auth.accessToken, dateQuery));
  };
  useEffect(() => {}, [renderData]);

  const statusChange = (ele, type) => {
    if (type === "STATUS") {
      dispatch(
        update_get_in_app_templates(
          auth.accessToken,
          ele._id,
          { status: !ele.status },
          (data) => {
            Alert.success(`<h4>Update Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
            onSuccess(data);
          },
          "edit"
        )
      );
    } else {
      dispatch(
        update_get_in_app_templates(
          auth.accessToken,
          ele._id,
          { confirmed: !ele.confirmed },
          (data) => {
            Alert.success(`<h4>Update Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
            onSuccess(data);
          },
          "edit"
        )
      );
    }
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3 col">
                  <div className="f24_700_HelveticaNeue ">
                    In App Notifications
                  </div>
                  <button
                    class="btn btn-danger btn2 btn-lg"
                    onClick={() => {
                      history.push("/superadminnotifyusersadd");
                    }}
                  >
                    Add In App Notification
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                      Sort
                    </div>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort(ele.title)}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        alt="Filter Icon"
                        onClick={() => setShowFilter(!showFilter)}
                      />
                      <br />
                      Filter
                    </div>
                    <CSVDownloader
                      filename={"settlement"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </div>
                {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Type
                            </InputLabel>
                            <Select
                              value={filter.type}
                              onChange={(e) =>
                                setFilter({ ...filter, type: e.target.value })
                              }
                              label="Status"
                              inputProps={{
                                name: "Status",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {filterData?.type.map((ele) => (
                                <MenuItem value={ele.value} key={ele.value}>
                                  {ele.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            type: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <div className="user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "10%" }} className="f12-700">
                          ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          User Type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Template Type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Title
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Headline
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Sub Text
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Status
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Start Date <br /> End Date
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Triggered Time
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderData.map((ele, i) => (
                        <DataToDisp
                          ele={ele}
                          history={history}
                          statusChange={statusChange}
                          key={ele?.id || ele?._id}
                        />
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const DataToDisp = ({ ele, history, statusChange, ...props }) => {
  const [show, setShow] = useState(false);
  const [Approvebtn, SeApproveBtn] = useState(false);

  const SeatDisable = () => {
    if (ele?.confirmed === true) {
      return true;
    } else {
      return Approvebtn;
    }
  };

  return (
    <>
      <tr
        className="super_admin_all_users_table_body mt-2"
        style={{ wordBreak: "break-word" }}
        onClick={() => setShow(!show)}
      >
        <td colSpan="7" className="p-0 w-100">
          <table className="w-100 HideShowTable enMinWidth900">
            <tbody>
              <tr>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{ele?.id || ele?._id}</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {ele.userType === "USER" ? "User" : "Vendor"}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {ele.templateType === "TEXT"
                      ? "Text"
                      : ele.templateType === "IMAGE"
                      ? "Image"
                      : "Text + Image"}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{ele?.title || ""}</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{ele?.heading?.text || ""}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500">{ele?.content?.text || ""}</div>
                </td>
                <td
                  style={{ width: "10%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div
                    className={
                      "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                    }
                  >
                    <input
                      type={"checkbox"}
                      name={"has_admin_approved"}
                      className={"toggle__switch vendor-super-admin-toggle"}
                      onChange={(e) => statusChange(ele, "STATUS")}
                      defaultChecked={ele.status}
                    />
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {moment(ele.startDate).format("ll")}
                    <br />
                    {moment(ele.endDate).format("ll")}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {ele.startTime} <br />
                    {ele.endTime}
                  </div>
                </td>
                <td
                  style={{ width: "10%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <div className="d-flex">
                    {/* <PopupActionButton
                      buttonText="Approve"
                      buttonType={"button"}
                      buttonClass="bigbuttonred"
                      onClick={(e) => statusChange(ele, "APPROVE")}
                      disabled={ele?.confirmed}
                    /> */}
                    <Button
                      variant="danger"
                      disabled={SeatDisable()}
                      className="px-2 py-2 btn f12-400 text-white"
                      // style={
                      //   ele?.confirmed === true
                      //     ? { backgroundColor: "#E0E0E0" }
                      //     : { backgroundColor: "#EE3A23" }
                      // }
                      onClick={
                        !ele.confirmed
                          ? () => {
                              statusChange(ele, "APPROVE");
                              SeApproveBtn(true);
                            }
                          : () => {}
                      }
                    >
                      Approve
                    </Button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      {show && (
        <React.Fragment>
          <tr
            className="mt-0 super-admin-suggestion-table-body"
            style={{
              borderTop: "1px solid #bfbfbf",
            }}
          >
            <td style={{ width: "10%" }}>
              <div className="f12-700">Actions</div>
              <div className="mt-2 d-flex align-items-center">
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  onClick={() => {
                    history.push({
                      pathname: "/superadminnotifyusersadd",
                      state: { data: ele },
                    });
                  }}
                >
                  <Image
                    fluid
                    alt="View"
                    title="View"
                    src={require("../../../../assets/images/UserManagement/eye.svg")}
                  />
                </Button>

                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  onClick={() => {
                    history.push({
                      pathname: "/superadminnotifyusersadd",
                      state: { data: ele },
                    });
                  }}
                >
                  <Image
                    fluid
                    alt="View"
                    title="View"
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  />
                </Button>
              </div>
            </td>
            <td style={{ width: "40%" }}>
              <div className="f12-700">Selected State</div>
              <div className="f12-400 mt-2">
                {ele.locationList.map((list) => (
                  <span style={{ padding: "0px 1px" }}>
                    <Chip size="small" label={list} />
                  </span>
                ))}
              </div>
            </td>
            <td style={{ width: "10%" }}>
              <div className="f12-700">Target Screen</div>
              <div className="mt-2">{ele?.targetScreen?.name || "NA"}</div>
            </td>
            <td style={{ width: "10%" }}>
              <div className="f12-700">Target Screen</div>
              <div className="mt-2">{ele?.targetScreen?.query || "NA"}</div>
            </td>
          </tr>
        </React.Fragment>
      )}
    </>
  );
};

export default SuperAdminNotifyUsers;
